import React, { AnchorHTMLAttributes, memo, useState } from 'react'
import { TooltipPositionTypes } from '../../libraries/Tooltips'
import { getMergedClassNames, getUniqueKey } from '../../utils/HTMLutils'
import './AnimatedLink.scss'
const rootClassName = 'component-animated-link'

interface AnimatedLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  'tooltip-position'?: TooltipPositionTypes
  'tooltip-text'?: string
  animated?: boolean
  
}
function AnimatedLink(props: AnimatedLinkProps) {
  const [id] = useState(props.id ? props.id : getUniqueKey())

  const getProps = () => {
    const p: any = {
      ...props,
      className: getMergedClassNames([
        rootClassName,
        props.className || '',
        props.animated ? 'animated' : ''
      ])
    }
    delete p.animated
    return p
  }

  return (
    <a {...getProps()} id={id}>
      {props.children}
    </a>
  )
}

AnimatedLink.defaultProps = {
  animated: true
}

export default memo(AnimatedLink)
